import { IApplicationState } from '../../types/redux';

export const selectResultsDominantRegionId = (state: IApplicationState) => {
  return state.results.dominantRegionId;
};
